import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { dataType } from "../dataType";
import { Router } from "@angular/router";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"]
})
export class DashboardComponent implements OnInit {
  public totalUsers = "--";
  public users;
  public totalGroups = "--";
  public groups;
  public totalBuckets = "--";
  public buckets;
  public totalIamUsers = "--";
  public iamUsers;
  public data: any;
  public objData: any;
  public bucketForChart = new dataType();
  public bucketArray =[];
  public ObjectArray = [];

  constructor(private dataService: DataService, private router: Router,private spinner: NgxSpinnerService) {
    this.data = {
      labels: ["jpg", "zip", "xls", "doc", "other"],
      datasets: [
        {
          data: [10, 10, 10, 10, 10],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#45f442",
            "#b3cccc"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#45f442",
            "#b3cccc"
          ]
        }
      ]
    };
    this.objData= {
            labels: ['Bucket1', 'Bucket2', 'Bucket3', 'Bucket4', 'Bucket5', 'Bucket6'],
            datasets: [
                {
                    label: 'Objects',
                    backgroundColor: '#42A5F5',
                    borderColor: '#1E88E5',
                    data: [18, 14, 10, 15, 21, 23]
                }
            ]
        }
    
  }

  ngOnInit() {
    this.spinner.show();
 
    setTimeout(() => {
        /** spinner ends after 2 seconds */
        this.spinner.hide();
    }, 4000);
    this.getUsers();
    this.getGroups();
    this.getBuckets();
    this.getIamUserList();
  }

  getUsers() {
    this.dataService.getUsersList().subscribe((res: any) => {
      // console.log(res);
      this.totalUsers = res.Data.Users.length;
      this.users = res.Data.Users;
      // this.getGroups();
    });
  }

  getGroups() {
    this.dataService.getGroupList().subscribe((res: any) => {
      // console.log(res);
      this.totalGroups = res.Data.Groups.length;
      this.groups = res.Data.Groups;
      console.log(this.groups);
      // this.getBuckets();
    });
  }

  getBuckets() {
    var i=0;
    this.dataService.getBucketList().subscribe((res: any) => {
      console.log(res);
      this.totalBuckets = res.Data.Buckets.length;
      this.buckets = res.Data.Buckets;
      console.log(this.buckets);
      this.buckets.forEach(bucket => {
        // console.log(bucket.Name)
        this.dataService.listS3Object({"bucketname": bucket.Name, "maxkey": 500}).subscribe((res:any)=>{
          // console.log(res.Data.Contents.length);
          this.ObjectArray.push(res.Data.Contents.length)
          this.bucketArray.push(bucket.Name)
          // console.log(this.buckets.length)
          // console.log(i)
          i++;
          if(this.buckets.length == i){
            this.createChart()
          }
        })
      });
    });
  }

  public chartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          stepSize: 20,
          beginAtZero: true
        }
      }]
    }    
  }

  getIamUserList(){
    this.dataService.getIamUsersList().subscribe((res:any)=>{
      if(typeof res == 'string'){
        res = JSON.parse(res);
      }     
      console.log(res)
      this.totalIamUsers = res.Data.Users.length
      this.iamUsers = res.Data.Users;
    })
  }

  createChart(){
    console.log(this.bucketArray)
    console.log(this.ObjectArray)
    this.objData= {
      labels: ['Bucket1','Bucket2','Bucket3', 'Bucket4', 'Bucket5','Bucket6','Bucket7',],
      datasets: [
          {
              label: 'Objects',
              backgroundColor: '#42A5F5',
              borderColor: '#1E88E5',
              data: this.ObjectArray,                
          }
      ]
  }
  }

  viewProfile(username): void {
    console.log(username);
    this.router.navigate(["/user-profile", { userName: username}]);
  }

  getObjects(bucketname) {
    console.log(bucketname)
    if(bucketname == undefined){
      return null;
    }else if(bucketname == '--Select Bucket--'){
      return null;
    }
    this.bucketForChart["maxkey"] = 500;
    console.log(this.bucketForChart);
    this.dataService.listS3Object(this.bucketForChart).subscribe((res: any) => {
      console.log(res);
      var jpg = 0,
        zip = 0,
        xls = 0,
        doc = 0,
        other = 0;
      for (var i = 0; i < res.Data.Contents.length; i++) {
        console.log(res.Data.Contents[i].Key.split(".")[1]);
        switch (res.Data.Contents[i].Key.split(".")[1]) {
          case "jpg":
            jpg++;
            break;
          case "zip":
            zip++;
            break;
          case "xls":
            xls++;
            break;
          case "doc":
            doc++;
            break;
          default:
            other++;
        }
      }
            this.data = {
        labels: ["jpg", "zip", "xls", "doc", "other"],
        datasets: [
          {
            data: [jpg, zip, xls, doc, other],
            backgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#45f442",
              "#b3cccc"
            ],
            hoverBackgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#45f442",
              "#b3cccc"
            ]
          }
        ]
      };
    });
  }

  showS3Object(bucket) {
    this.router.navigate([
      "/buckets/show-object",
      {
        bucketname: bucket,
        maxkey: 500,
        region: localStorage.getItem("region")
      }
    ]);
  }
}